import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import {
  Button,
  Grid,
  Stack,
  Typography,
} from '@mui/material';

import styles from './multiple-image-uploader.module.scss';

interface MultipleImageUploaderProps {
  onUploadMultipleImages: (event: React.ChangeEvent<HTMLInputElement>) => void;
  maxImages?: number;
  isDisabled?: boolean;
  title?: string;
  buttonText?: string;
}

const MultipleImageUploader: FC<MultipleImageUploaderProps> = ({
  onUploadMultipleImages,
  maxImages = 14,
  isDisabled = false,
  title,
  buttonText,
}) => {
  const { t } = useTranslation();

  const defaultTitle = t('clientMemory.selectMultipleImages');
  const defaultButtonText = t('clientMemory.uploadMultiple');

  return (
    <Grid container item xs={12} className={styles.justifyCenter}>
      <Grid
        item
        xs={12}
        className={`${styles.justifyCenter} flex`}
        style={{ marginTop: '20px' }}
      >
        <Stack
          className={`${styles.justifyCenter} tooltipWrapperInline`}
          direction="row"
        >
          <Typography variant="h6" noWrap>
            {title || defaultTitle}
          </Typography>
        </Stack>
      </Grid>

      <Grid
        item
        xs={12}
        style={{ marginBottom: '40px', marginTop: '10px' }}
      >
        <Grid container justifyContent="center">
          <Button
            className={styles.uploadMultipleButton}
            variant="contained"
            component="label"
            disabled={isDisabled}
          >
            {buttonText || defaultButtonText}
            <input
              type="file"
              multiple
              accept="image/*"
              hidden
              onChange={onUploadMultipleImages}
              onClick={(e) => {
                // Сбрасываем значение, чтобы повторный выбор тех же файлов триггерил onChange (особенно на Android)
                (e.currentTarget as HTMLInputElement).value = '';
              }}
              disabled={isDisabled}
            />
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default MultipleImageUploader; 